export enum TypeKinship {
	AVO = 'AVO',
	BISNETO = 'BISNETO',
	CONJUGE = 'CONJUGE',
	ENTEADO = 'ENTEADO',
	FILHO = 'FILHO',
	GENRO_NORA = 'GENRO_NORA',
	IRMAO = 'IRMAO',
	NETO = 'NETO',
	PADRASTO_MADRASTA = 'PADRASTO_MADRASTA',
	PAI_MAE = 'PAI_MAE',
	SOBRINHO = 'SOBRINHO',
	SOGRO = 'SOGRO',
	TIO = 'TIO',
	TITULAR = 'TITULAR',
}
